import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { PaginatedResponse } from '@app/entity';
import { Poll, PollResults } from '@app/entity/poll';
import { API_VERSION } from '@app/core/api.version';

@Injectable()
export class PollService {

  constructor(private http: HttpClient) {}

  getPolls(): Observable<PaginatedResponse<Poll>> {
    return this.http.get<PaginatedResponse<Poll>>(`/${API_VERSION}/polls/`);
  }

  sendResults(pollResults: PollResults): Observable<PollResults> {
    return this.http.post<PollResults>(`/${API_VERSION}/poll_results/`, pollResults);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/poll.service.ts